import { RouteConfig } from 'vue-router';

import AuthRoutes from '@/router/routes/auth';
import InfoRoutes from '@/router/routes/info';
import ControlRoutes from '@/router/routes/control';
import BusinessRoutes from '@/router/routes/business';
import SelfEmployeeRoutes from '@/router/routes/selfEmployee';
import PlatformsRoutes from '@/router/routes/platforms';
import ReportsRoutes from '@/router/routes/reports';
import Details from '@/router/routes/details';
import Mode from '@/router/routes/mode';
import Admin from '@/router/routes/admin';

const routes: Array<RouteConfig> = [
  Admin,
  AuthRoutes,
  InfoRoutes,
  ControlRoutes,
  Details,
  BusinessRoutes,
  SelfEmployeeRoutes,
  ReportsRoutes,
  Mode,
  PlatformsRoutes,
  {
    path: '*',
    redirect: '/auth',
  },
];

export default routes;
